import { DateTime } from 'luxon';
import { toast } from 'react-toastify';

function IndexedDb(name) {
    const database = {};
    database.name = name;
    database.storeName = `${name}Store`;
    database.noDb = window.indexedDB ? false : true;

    database.willSave = () => {
        if (database.noDb)
            toast.error('Banco de dados não suportado, os dados não estão sendo salvos');
    };

    const dbRequest = (operation) => {
        return new Promise((resolve, reject) => {
            // att version when update db schema
            const request = window.indexedDB.open(database.name, 1);

            request.onupgradeneeded = () => {
                const { result: db } = request;
                db.createObjectStore(database.storeName, {
                    keyPath: 'id',
                    unique: true,
                });
            };

            request.onerror = (e) => {
                reject(e);
            };

            request.onsuccess = () => {
                const { result: db } = request;
                const transaction = db.transaction(database.storeName, 'readwrite');
                const objectStore = transaction.objectStore(database.storeName, 'readwrite');
                const response = operation(objectStore);

                response.onerror = (err) => {
                    return reject(console.log(err));
                };

                response.onsuccess = () => {
                    return resolve(response.result);
                };
            };
        });
    };

    database.insert = async (item) => {
        if (database.noDb) {
            return null;
        }
        const oldData = await database.selectOne(item.id);

        if (!oldData) {
            const insert = await dbRequest((objectStore) => {
                item.started_at = DateTime.local().toFormat('yyyy-MM-dd hh:mm:ss');
                item.updated_at = DateTime.local().toFormat('yyyy-MM-dd hh:mm:ss');

                return objectStore.put(item);
            });

            return await database.selectOne(insert);
        } else {
            const update = { ...oldData, ...item };
            const insert = await dbRequest((objectStore) => {
                update.updated_at = DateTime.local().toFormat('yyyy-MM-dd hh:mm:ss');

                return objectStore.put(update);
            });

            return await database.selectOne(insert);
        }
    };

    database.selectOne = async (id) => {
        if (database.noDb) {
            return null;
        }
        return await dbRequest((objectStore) => {
            return objectStore.get(id);
        });
    };

    database.selectAll = async () => {
        if (database.noDb) {
            return null;
        }
        return await dbRequest((objectStore) => {
            return objectStore.getAll();
        });
    };

    database.resetTable = async () => {
        if (database.noDb) {
            return null;
        }
        window.indexedDB.deleteDatabase(database.name);
    };

    return database;
}

export default IndexedDb('afericao');
